import React, { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import AgentMainDashboardAnalytics from './AgentMainDashboardAnalytics'
import AgentIndex from './agentDashboard'
import AgentCard from './Report/index'
import SupplierDashboard from './supplierDashboard'
import AdvanceSupplierDashboad from './advanceSupplierDashboard/index'
import ChatHistoryReport from '../chatHistoryReport'
import ChatRoom from '../../components/conversations/ChatRoom'

const Index = () => {
  const [isChatroomId, setChatRoomId] = useState<number>(0)

  return (
    <Routes>
      <Route
        path='/agent-dashboard'
        element={
          <>
            <AgentMainDashboardAnalytics />
          </>
        }
      />
      <Route
        path='/agent-dashboard/:uuid'
        element={
          <>
            <AgentIndex />
          </>
        }
      />
      <Route
        path='/supplier-dashboard'
        element={
          <>
            <SupplierDashboard />
          </>
        }
      />
      <Route
        path='/advance-supplier-dashboard'
        element={
          <>
            <AdvanceSupplierDashboad />
          </>
        }
      />
      <Route
        path='/all-report'
        element={
          <>
            <AgentCard />
          </>
        }
      />
      <Route
        path='/chatHistory-report'
        element={
          <>
            <ChatHistoryReport setChatRoomId={setChatRoomId} />
          </>
        }
      />
      <Route
        path='/chatHistory-report/:chatroomId'
        element={
          <div className='d-flex flex-column flex-lg-row mt-4 mx-4'>
            <ChatRoom
              type={'Chat-Report'}
              chatRoomID={isChatroomId}
              setSearchParams={() => {}} // Default empty function
              setIsData2={() => {}} // Default empty function
              setIsData3={() => {}}
              searchParams={() => {}}
              handleOpenChat={() => {}}
              handleCloseChat={() => {}}
              handleMinimizeChat={() => {}}
              chatPanels={() => {}}
              disabledIndexes={() => {}}
            />
          </div>
        }
      />
      <Route index element={<Navigate to='/report/all-report' />} />
    </Routes>
  )
}

export default Index
